<template>
  <a-modal
    title="编辑群发任务"
    :width="600"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @cancel="handleCancel"
    :maskClosable="false"
  >
    <a-spin :spinning="confirmLoading || dataLoading">
      <a-form :form="form">
        <a-form-item label="选择群发范围" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select
            v-decorator="['broadcast_type', { initialValue: 1, rules: [{ required: true, message: '必填项' }] }]"
          >
            <a-select-option :value="1">全部微信好友</a-select-option>
            <a-select-option :value="2">指定分组会员</a-select-option>
          </a-select>
        </a-form-item>
        <div v-show="formData['broadcast_type'] == 2">
          <a-form-item label="选择会员分组" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-select
              mode="multiple"
              v-decorator="['group_name', { initialValue: [] }]"
              placeholder="请选择"
              allowClear
            >
              <a-select-option v-for="item in groups" :key="item">{{ item }}</a-select-option>
            </a-select>
          </a-form-item>
        </div>
        <a-form-item label="消息类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select
            placeholder="请选择"
            v-decorator="['message_type', { rules: [{ required: true, message: '必填项' }] }]"
          >
            <a-select-option :value="1">文本消息</a-select-option>
            <a-select-option :value="2">图片消息</a-select-option>
            <a-select-option :value="3">卡片消息</a-select-option>
          </a-select>
        </a-form-item>
        <div v-show="formData['message_type'] == 1">
          <a-form-item label="文本消息" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-textarea
              placeholder="请输入"
              :autosize="{ minRows: 3, maxRows: 6 }"
              :pressEnter="() => {}"
              v-decorator="['message_text_content']"
            />
          </a-form-item>
        </div>
        <div v-show="formData['message_type'] == 2">
          <a-form-item label="图片消息" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <div class="clearfix">
              <a-upload
                action="https://upload-z2.qiniup.com"
                listType="picture-card"
                v-decorator="[
                  'message_text_picture',
                  {
                    valuePropName: 'fileList',
                    getValueFromEvent: normFile,
                  },
                ]"
                :data="{ token: UploadToken }"
                @preview="handlePicturePreview"
                :beforeUpload="beforeUpload"
              >
                <div v-if="!formData['message_text_picture'] || formData['message_text_picture'].length < 1">
                  <a-icon type="plus" />
                  <div class="ant-upload-text">上传图片</div>
                </div>
              </a-upload>
            </div>
          </a-form-item>
        </div>
        <div v-show="formData['message_type'] == 3">
          <a-form-item label="卡片消息-标题" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input placeholder="请输入" v-decorator="['message_text_card_title']" />
          </a-form-item>
          <a-form-item label="卡片消息-描述" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input placeholder="请输入" v-decorator="['message_text_card_desc']" />
          </a-form-item>
          <a-form-item label="卡片消息-图片" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input placeholder="请输入" v-decorator="['message_text_card_img']" />
          </a-form-item>
          <a-form-item label="卡片消息-链接" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input placeholder="请输入" v-decorator="['message_text_card_url']" />
          </a-form-item>
        </div>
        <a-form-item label="是否发送名片" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-switch v-decorator="['send_card', { valuePropName: 'checked' }]" />
        </a-form-item>
        <div v-show="formData['send_card'] == true">
          <a-form-item label="名片内容" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-button
              v-if="!usercard"
              @click="$refs.selectFansModal.show({ robotid: currentRobotId })"
              :style="{ marginRight: '5px' }"
              >选择</a-button
            >
            <a-button
              v-if="usercard"
              @click="
                () => {
                  this.usercard = null
                }
              "
              >删除</a-button
            >
            <div v-if="usercard">
              <a-card hoverablen>
                <a-card-meta :title="usercard.nickname" :description="usercard.wxid">
                  <a-avatar slot="avatar" :src="usercard.avatar" />
                </a-card-meta>
              </a-card>
            </div>
          </a-form-item>
        </div>
        <a-form-item label="每日发送人数" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="['number_per_day', { rules: [{ required: true, message: '必填项' }] }]" />
        </a-form-item>
        <a-form-item label="延迟时长(秒)" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="['message_delay', { rules: [{ required: true, message: '必填项' }] }]" />
        </a-form-item>
      </a-form>
    </a-spin>
    <template slot="footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button :loading="confirmLoading" :disabled="dataLoading" type="primary" @click="handleSubmit">确定</a-button>
    </template>
    <a-modal :visible="previewPictureVisible" :footer="null" @cancel="handlePictureCancel">
      <img alt="example" style="width: 100%" :src="previewPictureImage" />
    </a-modal>
    <select-fans-modal ref="selectFansModal" @change="onChangeFans"></select-fans-modal>
  </a-modal>
</template>

<script>
import FansApi from '@/api/fans'
import SelectFansModal from '@/views/components/SelectFansModal'
import ProgramApi from '@/api/program'
import GrouppushApi from '@/api/grouppush'
export default {
  components: {
    SelectFansModal,
  },
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 },
      },
      mdl: {},
      visible: false,
      confirmLoading: false,
      form: null,
      dataLoading: false,
      formData: {},
      currentRobotId: null,
      groups: [],
      previewPictureVisible: false,
      previewPictureImage: '',
      usercard: null,
      UploadToken: '',
      id: null,
    }
  },
  created() {
    this.form = this.$form.createForm(this, {
      onValuesChange: (_, values) => {
        Object.assign(this.formData, values)
      },
    })
  },
  methods: {
    show(robot_id, id) {
      this.currentRobotId = robot_id
      this.id = id
      this.visible = true
      this.getGroups()
      this.getData()
    },
    getData() {
      this.dataLoading = true
      GrouppushApi.getTask({ sub_id: this.currentRobotId, id: this.id })
        .then((res) => {
          if (res.code === 1) {
            const data = res.data
            let values = {
              broadcast_type: data.broadcast_type,
              group_name: data.group_name ? JSON.parse(data.group_name) : [],
              message_type: data.message_type,
              send_card: data.send_card == 1 ? true : false,
              number_per_day: data.number_per_day,
              message_delay: data.message_delay,
            }
            if (data.card_message) {
              this.usercard = JSON.parse(data.card_message)
            }
            if (values.message_type == 1) {
              values.message_text_content = data.message ? JSON.parse(data.message).text : ''
            } else if (values.message_type == 2) {
              const messageImgData = JSON.parse(data.message)
              values.message_text_picture = [
                {
                  uid: '-1',
                  name: messageImgData.fname,
                  status: 'done',
                  url: this.getQiniuUrl(messageImgData),
                  response: messageImgData,
                },
              ]
            } else if (values.message_type == 3) {
              const cardData = this.getSortCardData(data.message)
              values.message_text_card_title = cardData.title
              values.message_text_card_desc = cardData.desc
              values.message_text_card_img = cardData.img
              values.message_text_card_url = cardData.url
            }
            this.form.setFieldsValue(values)
          } else {
            this.$message.error(res.msg)
          }
        })
        .finally(() => {
          this.dataLoading = false
        })
    },
    getGroups() {
      FansApi.getGroupList({
        sub_id: this.currentRobotId,
      }).then((res) => {
        const list = res.data
        this.groups = list.map((item) => {
          return item.name
        })
      })
    },
    handleCancel() {
      this.visible = false
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          let message = {}
          if (values.message_type == 1) {
            message = { text: values.message_text_content }
          } else if (values.message_type == 2) {
            message = values.message_text_picture[0].response
          } else if (values.message_type == 3) {
            message = {
              title: values.message_text_card_title,
              desc: values.message_text_card_desc,
              img: values.message_text_card_img,
              url: values.message_text_card_url,
            }
          }
          const params = {
            broadcast_type: values.broadcast_type,
            group_name: JSON.stringify(values.group_name),
            message_type: values.message_type,
            message: JSON.stringify(message),
            send_card: values.send_card ? 1 : 0,
            card_message: this.usercard ? JSON.stringify(this.usercard) : null,
            number_per_day: values.number_per_day,
            message_delay: values.message_delay,
            sub_id: this.currentRobotId,
            id: this.id,
          }
          this.confirmLoading = true
          GrouppushApi.updateTask(params)
            .then((res) => {
              if (res.code === 1) {
                this.$message.success('提交成功')
                this.visible = false
                this.$emit('ok')
              } else {
                this.$message.error(res.msg)
              }
            })
            .finally(() => {
              this.confirmLoading = false
            })
        }
      })
    },
    handlePictureCancel() {
      this.previewPictureVisible = false
    },
    handlePicturePreview(file) {
      this.previewPictureImage = file.url || file.thumbUrl
      this.previewPictureVisible = true
    },
    normFile(e) {
      if (Array.isArray(e)) {
        return e
      }
      return e && e.fileList
    },
    onChangeFans(data) {
      let wwid = data.wwid
      wwid = wwid.replace(/-/g, 'p')
      wwid = wwid.replace(/\*/g, 'o')
      wwid = wwid.replace(/&/g, 'i')
      wwid = wwid.replace(/\^/g, 'u')
      this.usercard = {
        wxid: window.atob(wwid),
        nickname: data.nickname,
        avatar: data.avatar,
        uid: data.uid,
      }
      this.$refs.selectFansModal.handleCancel()
    },
    beforeUpload(file) {
      return new Promise((resolve, reject) => {
        const isLt25M = file.size / 1024 / 1024 < 25
        if (!isLt25M) {
          this.$message.error('由于微信限制，上传文件不能大于25M!')
          reject()
        }
        ProgramApi.getQiniuToken()
          .then((response) => {
            if (response.code === 1) {
              const token = response.data
              this.UploadToken = token
              setTimeout(() => {
                resolve()
              }, 100)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getSortCardData(str) {
      const obj = str ? JSON.parse(str) : {}
      const imgData = obj.img
      const res = {
        title: obj.title,
        desc: obj.desc,
        img: [
          {
            uid: '-1',
            name: imgData.fname,
            status: 'done',
            url: this.getQiniuUrl(imgData),
            response: imgData,
          },
        ],
        url: obj.url,
      }
      return res
    },
    getQiniuUrl(obj) {
      return `http://${obj.domain}/${obj.fkey}`
    },
  },
}
</script>
